if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.navCreated = false;
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.createMobileNav();
        this.updateCounter();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
      }

      getActiveIndex() {
        const items = this.getMediaItems();
        return items.findIndex(el => el.classList.contains('active'));
      }

      navigateTo(index) {
        const items = this.getMediaItems();
        if (index < 0 || index >= items.length) return;
        items.forEach(el => el.classList.remove('active'));
        items[index].classList.add('active');
        this.updateCounter();
      }

      navigateNext() {
        const items = this.getMediaItems();
        const current = this.getActiveIndex();
        const next = (current + 1) % items.length;
        this.navigateTo(next);
      }

      navigatePrev() {
        const items = this.getMediaItems();
        const current = this.getActiveIndex();
        const prev = (current - 1 + items.length) % items.length;
        this.navigateTo(prev);
      }

      updateCounter() {
        const counter = this.querySelector('.modal-nav__counter');
        if (!counter) return;
        const items = this.getMediaItems();
        const current = this.getActiveIndex();
        counter.textContent = (current + 1) + ' / ' + items.length;
      }

      createMobileNav() {
        if (this.navCreated) return;
        if (window.innerWidth > 749) return;
        const items = this.getMediaItems();
        if (items.length < 2) return;

        const dialog = this.querySelector('.product-media-modal__dialog');
        if (!dialog) return;

        // Prev button
        const prevBtn = document.createElement('button');
        prevBtn.className = 'modal-nav__prev';
        prevBtn.type = 'button';
        prevBtn.setAttribute('aria-label', 'Previous image');
        prevBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';
        prevBtn.addEventListener('click', (e) => { e.stopPropagation(); this.navigatePrev(); });

        // Next button
        const nextBtn = document.createElement('button');
        nextBtn.className = 'modal-nav__next';
        nextBtn.type = 'button';
        nextBtn.setAttribute('aria-label', 'Next image');
        nextBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';
        nextBtn.addEventListener('click', (e) => { e.stopPropagation(); this.navigateNext(); });

        // Counter
        const counter = document.createElement('div');
        counter.className = 'modal-nav__counter';

        dialog.appendChild(prevBtn);
        dialog.appendChild(nextBtn);
        dialog.appendChild(counter);

        // Swipe support
        let startX = 0;
        const content = this.querySelector('.product-media-modal__content');
        if (content) {
          content.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
          content.addEventListener('touchend', (e) => {
            const diff = startX - e.changedTouches[0].clientX;
            if (Math.abs(diff) > 50) {
              if (diff > 0) this.navigateNext();
              else this.navigatePrev();
            }
          }, { passive: true });
        }

        this.navCreated = true;
      }
    }
  );
}
